import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { getFormInitialValues } from 'redux-form'

export const PhoneVerification = ({ index, isVerified, onClick }) => {
  const { t } = useTranslation('common')

  return isVerified ? (
    <div className='info-verifikacija info-verifikacija-mobilni info-verifikacija-true'>
      <p>{t('Verifikovan mobilni broj')}</p>
    </div>
  ) : (
    <div className='info-verifikacija info-verifikacija-mobilni2 info-verifikacija-false'>
      <a href='javascript:void(0)' onClick={() => { onClick(index) }}>{t('Verifikuj mobilni telefon')}</a>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const props = { isVerified: false }
  const initValues = getFormInitialValues('update')(state)
  if (initValues.phones && Array.isArray(initValues.phones)) {
    const searchedPhone = initValues.phones.filter((item, index) => index === ownProps.index)
    if (searchedPhone.length) {
      props.isVerified = true
    }
  }
  return props
}

PhoneVerification.propTypes = {
  isVerified: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
}

PhoneVerification.defaultProps = {
  isVerified: false,
  index: 0
}

export default connect(mapStateToProps)(PhoneVerification)
